import type { ReactNode } from 'react'

/** `Un'azienda *organizzata*, …` → the starred words as <em class="text-vc2-accent"> (italic by default). */
export function emphasize(text: string): ReactNode[] {
  return text.split('*').map((part, i) => (i % 2 ? <em key={i} className="text-vc2-accent">{part}</em> : part))
}
